import React from 'react';
import { stats } from '../data/content';
import { Reveal } from './Reveal';
import { StatNumber } from './StatNumber';
export function StatsBar() {
  return <section className="relative w-full overflow-hidden bg-ink py-16 sm:py-20" data-id="element-219" data-mp="1t8dpg2onwiee">
      <div className="bg-court-dark absolute inset-0" aria-hidden="true" data-id="element-220" data-mp="1o9u4a4hw7an3" />
      <div className="relative mx-auto max-w-6xl px-5" data-id="element-221" data-mp="1jb92w1qwmkx2">
        <Reveal data-id="element-222" data-mp="1ed7jtgthalll">
          <h2 className="text-center font-display text-2xl tracking-[0.02em] text-white sm:text-3xl" data-id="element-223" data-mp="1ecz9nwoqpue3">
            Los números <span className="text-volt" data-id="element-224" data-mp="19m8zm65dd3d2">no mienten</span>
          </h2>
        </Reveal>

        <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-4 md:gap-y-0" data-id="element-225" data-mp="15ke3dg2apg65">
          {stats.map((stat, index) => <Reveal key={stat.label} delay={index * 0.05} className={`text-center ${index > 0 ? 'md:border-l md:border-white/15' : ''}`} data-id="element-226" data-mp="10mvoza5ie8qr" data-mpi={index}>
              <dt className="sr-only" data-id="element-227" data-mp="vou5wp8329fa">{stat.label}</dt>
              <dd data-id="element-228" data-mp="qoobx2eccau1">
                <StatNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} className="block font-display text-[2.7rem] leading-none text-volt sm:text-6xl" data-id="element-229" data-mp="qo6jkgusugre" />
                <span className="mx-auto mt-4 block max-w-[13rem] text-sm font-semibold leading-snug text-white/70" data-id="element-230" data-mp="3tf2dzawbwokm">
                  {stat.label}
                </span>
              </dd>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}